var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-2278e148"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["id"];
var _hoisted_2 = ["aria-checked", "role", "tabindex"];
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "e-checkbox__inner" }, null, -1); });
var _hoisted_4 = ["aria-hidden", "disabled", "name", "tabindex", "value"];
var _hoisted_5 = {
    key: 0,
    class: "e-checkbox__label"
};
import { computed, inject, ref } from 'vue';
import { provideCheckBoxGroupKey } from '@common/ui/ECheckbox/provideKey';
import EError from '@common/ui/EError/EError.vue';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false
}, { __name: 'ECheckbox', props: /*#__PURE__*/ _mergeModels({
        value: { type: [String, Number, Boolean] },
        name: {},
        label: {},
        tabIndex: { default: 0 },
        id: {},
        hideLabel: { type: Boolean },
        disabled: { type: Boolean },
        indeterminate: { type: Boolean },
        fakeChecked: { type: Boolean },
        border: { type: Boolean },
        size: { default: 'medium' },
        theme: { default: 'primary' },
        unstyled: { type: Boolean, default: false },
        error: { type: Boolean },
        parentFit: { type: Boolean },
        hideError: { type: Boolean },
        position: {},
        rule: {},
        validateOnMount: { type: Boolean }
    }, {
        "checked": __assign({ type: Boolean }, { required: false, default: false }),
        "checkedModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["change"], ["update:checked"]), setup: function (__props, _a) {
        var __emit = _a.emit;
        var checkBoxGroup = inject(provideCheckBoxGroupKey);
        var props = __props;
        var emit = __emit;
        var focus = ref(false);
        var isErrored = ref(false);
        // ручками ставим чекед
        var checked = _useModel(__props, 'checked');
        var checkedModel = computed({
            get: function () {
                return checkBoxGroup ? checkBoxGroup.checkboxGroupValues.value : checked.value;
            },
            set: function (v) {
                if (checkBoxGroup) {
                    checkBoxGroup.updateCheckboxGroupValues(v);
                    return;
                }
                checked.value = v;
            }
        });
        var isDisabled = computed(function () {
            return (checkBoxGroup === null || checkBoxGroup === void 0 ? void 0 : checkBoxGroup.checkboxGroupDisabled.value) || props.disabled;
        });
        var isChecked = computed(function () {
            if (props.fakeChecked) {
                return props.fakeChecked;
            }
            if (checkBoxGroup) {
                return checkBoxGroup.checkboxGroupValues.value.includes(props.value);
            }
            return checked.value;
        });
        var checkboxSize = computed(function () {
            // можно в provideCheckBoxGroupKey прокидывать
            return props.size;
        });
        var themeClass = computed(function () {
            return {
                primary: 'e-checkbox--primary',
                white: 'e-checkbox--white',
                dark: 'e-checkbox--dark',
            }[props.theme];
        });
        var handleChange = function () {
            emit('change', checked.value);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EError, {
                class: _normalizeClass([
                    _ctx.parentFit && '!w-auto'
                ]),
                "hide-error": _ctx.hideError,
                name: _ctx.name,
                position: _ctx.position,
                rule: _ctx.rule,
                value: isChecked.value,
                onChangeErrorStatus: _cache[3] || (_cache[3] = function ($event) { return (isErrored.value = $event); })
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("label", _mergeProps({ id: _ctx.id }, _ctx.$attrs, {
                        class: [[
                                themeClass.value,
                                checkboxSize.value ? 'e-checkbox--' + checkboxSize.value : '',
                                {
                                    'is-disabled': isDisabled.value,
                                    'is-bordered': _ctx.border,
                                    'is-checked': isChecked.value,
                                    'is-unstyled': _ctx.unstyled
                                },
                            ], "e-checkbox"]
                    }), [
                        _createElementVNode("span", {
                            "aria-checked": _ctx.indeterminate ? 'mixed' : false,
                            class: _normalizeClass([{
                                    'is-disabled': isDisabled.value,
                                    'is-checked': isChecked.value,
                                    'is-indeterminate': _ctx.indeterminate,
                                    'is-focus': focus.value,
                                    'is-error': _ctx.error
                                }, "e-checkbox__input"]),
                            role: _ctx.indeterminate ? 'checkbox' : false,
                            tabindex: _ctx.indeterminate ? 0 : false
                        }, [
                            _hoisted_3,
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((checkedModel).value = $event); }),
                                "aria-hidden": _ctx.indeterminate ? 'true' : 'false',
                                disabled: isDisabled.value,
                                name: _ctx.name,
                                tabindex: _ctx.tabIndex,
                                value: _ctx.value,
                                class: "e-checkbox__original",
                                type: "checkbox",
                                onBlur: _cache[1] || (_cache[1] = function ($event) { return (focus.value = false); }),
                                onChange: handleChange,
                                onFocus: _cache[2] || (_cache[2] = function ($event) { return (focus.value = true); })
                            }, null, 40, _hoisted_4), [
                                [_vModelCheckbox, checkedModel.value]
                            ])
                        ], 10, _hoisted_2),
                        (!_ctx.hideLabel && (_ctx.$slots.default || _ctx.label))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _renderSlot(_ctx.$slots, "default", { checked: isChecked.value }, function () { return [
                                    _createTextVNode(_toDisplayString(_ctx.label), 1)
                                ]; })
                            ]))
                            : _createCommentVNode("", true)
                    ], 16, _hoisted_1)
                ]; }),
                _: 3
            }, 8, ["class", "hide-error", "name", "position", "rule", "value"]));
        };
    } }));
